export const getBookFlowId = state => state.bookFlows.bookFlow.id;
export const getBookFlowData = state => state.bookFlows.bookFlow;
export const bookFlowIsFetching = state => state.bookFlows.loading;